export default __webpack_public_path__ + "static/media/imagen01.9aaf50e1.svg";